export default __webpack_public_path__ + "static/media/polegar-para-cima.70bcb573.png";